/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.form-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  margin-top: 10px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvaW5zcGVjdGlvbi1lcXVpcG1lbnRzL2F1dG9jb21wbGV0ZS1pbnNwZWN0aW9uLWVxdWlwbWVudC9hdXRvY29tcGxldGUtaW5zcGVjdGlvbi1lcXVpcG1lbnQuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvaW5zcGVjdGlvbi1lcXVpcG1lbnRzL2F1dG9jb21wbGV0ZS1pbnNwZWN0aW9uLWVxdWlwbWVudC9hdXRvY29tcGxldGUtaW5zcGVjdGlvbi1lcXVpcG1lbnQuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/inspection-equipments/autocomplete-inspection-equipment/autocomplete-inspection-equipment.component.scss.shim.ngstyle.ts